import { API_CONFIG } from '../config/apiConfig';

const LEAD_GATE_KEY = 'calculatorLeadGatePassed';
const LEAD_EMAIL_KEY = 'calculatorLeadEmail';

export const hasPassedLeadGate = () => {
  try {
    return sessionStorage.getItem(LEAD_GATE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const markLeadGatePassed = (email = null) => {
  try {
    sessionStorage.setItem(LEAD_GATE_KEY, 'true');
    if (email) {
      sessionStorage.setItem(LEAD_EMAIL_KEY, email.trim().toLowerCase());
    }
  } catch (error) {
    console.warn('No se pudo persistir el estado del lead gate:', error);
  }
};

export const getCapturedLeadEmail = () => {
  try {
    return sessionStorage.getItem(LEAD_EMAIL_KEY) || null;
  } catch {
    return null;
  }
};

export const clearLeadGateState = () => {
  try {
    sessionStorage.removeItem(LEAD_GATE_KEY);
    sessionStorage.removeItem(LEAD_EMAIL_KEY);
  } catch (error) {
    console.warn('No se pudo limpiar el estado del lead gate:', error);
  }
};

/**
 * Envía un lead liviano de calculadora reutilizando el endpoint de contacto.
 */
export const captureCalculatorLead = async ({ email, name, company }) => {
  const normalizedEmail = email?.trim().toLowerCase();
  if (!normalizedEmail) {
    throw new Error('El email es obligatorio');
  }

  const payload = {
    name: name?.trim() || 'Visitante calculadora',
    company: company?.trim() || 'No especificada',
    email: normalizedEmail,
    phone: '-',
    message:
      'Lead captado desde la calculadora antes de visualizar resultados. Fuente: calculator_lead_gate',
  };

  const url = `${API_CONFIG.USER_API.BASE_URL}${API_CONFIG.USER_API.ENDPOINTS.CONTACT}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.error || 'No se pudo guardar el lead');
  }

  markLeadGatePassed(normalizedEmail);
  return data;
};

const LANDING_LEAD_MESSAGES = {
  demo: 'Solicitud de demo desde la web. Fuente:',
  optrim_waitlist: 'Alta en lista de espera Optrim. Fuente:',
};

/**
 * Envía un lead desde modales de landing (demo o lista de espera Optrim).
 */
export const captureLandingLead = async ({
  variant = 'demo',
  email,
  name,
  company,
  phone,
  source = 'unknown',
  page,
}) => {
  const normalizedEmail = email?.trim().toLowerCase();
  if (!normalizedEmail) {
    throw new Error('El email es obligatorio');
  }

  const baseMessage = LANDING_LEAD_MESSAGES[variant] || LANDING_LEAD_MESSAGES.demo;
  const pageSuffix = page ? ` | Página: ${page}` : '';

  const payload = {
    name: name?.trim() || (variant === 'optrim_waitlist' ? 'Lista de espera Optrim' : 'Solicitud de demo'),
    company: company?.trim() || 'No especificada',
    email: normalizedEmail,
    phone: phone?.trim() || '-',
    message: `${baseMessage} ${source}${pageSuffix}`,
  };

  const url = `${API_CONFIG.USER_API.BASE_URL}${API_CONFIG.USER_API.ENDPOINTS.CONTACT}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.error || 'No se pudo enviar la solicitud');
  }

  return data;
};
